module.exports = __webpack_public_path__ + "img/46284.4dfef768.jpg";